import axios from "axios";
import { BASE_URL } from './config.properties';

const httpClient = axios.create({
    baseURL: BASE_URL,
});

class ApiService {
    constructor(apiurl) {
        this.apiurl = apiurl;
    }

    post(url, obj) {
        return httpClient.post(url, obj);
    }

    put(url, obj) {
        return httpClient.put(url, obj);
    }

    get(url) {
        return httpClient.get(url);
    }

    delete(url) {
        return httpClient.delete(url);
    }
}

export default ApiService;
